import { render, staticRenderFns } from "./gtr-text-editor.vue?vue&type=template&id=a6ffded8&scoped=true"
import script from "./gtr-text-editor.ts?vue&type=script&lang=ts&external"
export * from "./gtr-text-editor.ts?vue&type=script&lang=ts&external"
import style0 from "./gtr-text-editor.vue?vue&type=style&index=0&id=a6ffded8&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6ffded8",
  null
  
)

export default component.exports